'use client';

import BaseButton from '@/components/Button/BaseButton';
import { FC, useContext } from 'react';
import AlgonomyContext, { AlgonomyContextState } from '../../../context/SearchResultsContext';
import { SortFilterProps } from './types';
import styles from './SortFilter.module.css';
import { clsx } from 'clsx';
// import SelectCustom from '@/components/Select/SelectCustom';
// import { SortingSelectObtion } from '@/containers/ProductPage/sort-comments/types';

const SortFilter: FC<SortFilterProps> = ({ selectedFilter = 'score', selectedAmount, className }) => {
  const { openFilter, setOpenFilter, handleSort } = useContext(AlgonomyContext) as AlgonomyContextState;

  const sortOptions = [
    {
      label: 'Best match',
      selected: false,
      available: true,
      value: 'score'
    },
    {
      value: 'popularity',
      selected: false,
      available: true,
      label: 'Popularity'
    },
    {
      value: 'asc',
      selected: false,
      available: true,
      label: 'Price Low to High'
    },
    {
      value: 'desc',
      selected: false,
      available: true,
      label: 'Price High to Low'
    },
    {
      value: 'rating',
      selected: false,
      available: true,
      label: 'Rating'
    },
  ]

  return (
    <div className={clsx(styles.sortFilter, className)}>

{/* <div className={styles.sortContainer}>
      <span>Sort by: </span>
      <SelectCustom<SortingSelectObtion>
        title="Sort by:"
        options={sortOptions}
        placeholder={selectedFilter}
        dropdownClasses={styles.sortSelect}
        arrowClasses={styles.arrow}
        onChange={(option: SortingSelectObtion) => {
          handleSort(option.value);
        }}
        hideSelected={true}
      />
    </div> */}
      <BaseButton
        id={'sort-filter-btn'}
        label={`Filter${selectedAmount > 0 ? ` (${selectedAmount})` : ''}`}
        classes={styles.filterButton}
        onClick={() => setOpenFilter(!openFilter)}
        ariaLabel={`Filter${selectedAmount > 0 ? ` (${selectedAmount})` : ''}`}
      />
      <div className={styles.sortContainer}>
        <label htmlFor="sort" className={styles.sortLabels}>
          <span className={styles.sortLabel}>{'Sort by: '}</span>
          <select
            data-testid={'sort-filter-select'}
            name="sort"
            id="sort"
            defaultValue={selectedFilter}
            className={styles.sortSelect}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
              handleSort(event.target.value);
            }}
          >
            <option value="score">{'Best match'}</option>
            <option value="popularity">{'Popularity'}</option>
            <option value="asc">{'Price Low to High'}</option>
            <option value="desc">{'Price High to Low'}</option>
            <option value="rating">{'Rating'}</option>
          </select>
        </label>
      </div>
    </div>
  );
};

export default SortFilter;
